/**
 * Review-state helpers for run-report case rows (stored on each case in report JSON).
 */

export const isReportCaseReviewed = (caseItem) => caseItem?.reviewed === true;

export const summarizeReportCaseReviews = (cases) => {
  let reviewed = 0;
  let needsReview = 0;
  (cases || []).forEach((caseItem) => {
    if (isReportCaseReviewed(caseItem)) reviewed += 1;
    else needsReview += 1;
  });
  return { reviewed, needsReview, total: (cases || []).length };
};

/**
 * @param {Object} report
 * @param {Object} caseItem - Target case row (matched by case_index or name).
 * @param {boolean} reviewed
 * @returns {Object}
 */
export const setReportCaseReviewed = (report, caseItem, reviewed, matchReportCase) => {
  if (!report) return report;
  const updatedCases = (report.cases || []).map((c) => {
    if (!matchReportCase(c, caseItem)) return c;
    if (reviewed) {
      return { ...c, reviewed: true, reviewed_at: new Date().toISOString() };
    }
    const next = { ...c };
    delete next.reviewed;
    delete next.reviewed_at;
    return next;
  });
  return { ...report, cases: updatedCases };
};
